import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Events/hooks/useEventComments.ts
var useEventComments = (args, opts = {}) => {
	const { call, data, isCalling } = useRPC(RPCs.Events.GetEventComments.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
};
//#endregion
export { useEventComments };

//# sourceMappingURL=useEventComments.js.map